import React, { useEffect, useMemo, useState } from 'react';
import { useDataCache } from '../context/DataCacheContext';
import './CacheStatusBar.css';

function formatAge(ageMs) {
  if (!Number.isFinite(ageMs) || ageMs < 0) return '0s';
  const totalSeconds = Math.floor(ageMs / 1000);
  if (totalSeconds < 60) return `${totalSeconds}s`;
  const totalMinutes = Math.floor(totalSeconds / 60);
  if (totalMinutes < 60) return `${totalMinutes}m`;
  const totalHours = Math.floor(totalMinutes / 60);
  if (totalHours < 24) return `${totalHours}h`;
  const totalDays = Math.floor(totalHours / 24);
  return `${totalDays}d`;
}

export default function CacheStatusBar({
  cacheKey,
  onRefresh,
  isRefreshing = false,
  className = '',
  hideStaleTag = false,
}) {
  const dataCache = useDataCache();
  const [nowMs, setNowMs] = useState(Date.now());

  useEffect(() => {
    const id = setInterval(() => setNowMs(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const entry = dataCache.getCacheEntry(cacheKey);
  const fetchedAtMs = entry?.fetchedAtMs;

  const label = useMemo(() => {
    if (!fetchedAtMs) return 'Last updated: never';
    const ageMs = nowMs - fetchedAtMs;
    const staleTag = !hideStaleTag && entry?.stale ? ' (stale)' : '';
    return `Last updated: ${formatAge(ageMs)} ago${staleTag}`;
  }, [entry?.stale, fetchedAtMs, hideStaleTag, nowMs]);

  return (
    <div className={`cache-status-bar ${className}`.trim()}>
      <span className="cache-status-bar__text">{label}</span>
      {typeof onRefresh === 'function' && (
        <button
          type="button"
          className="cache-status-bar__btn"
          onClick={onRefresh}
          disabled={isRefreshing}
          aria-label="Refresh"
          title="Refresh"
        >
          {isRefreshing ? 'Refreshing…' : 'Refresh'}
        </button>
      )}
    </div>
  );
}

